const initialState = {
    gcContext: null,   // full meta_data JSON for the loaded group
    isSaving: false,
    isLoading: false,
};

export default initialState;
